const config = {
  base_path: 'criticalincident/',
  debug: false
};

export default config;